import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4810d5c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  colspan: "2",
  style: {"text-align":"center"}
}
const _hoisted_4 = { class: "card-catelog" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Price:", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Details:", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Specification:", -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Description:", -1))
const _hoisted_12 = ["innerHTML"]

import { ArrowLeft, ShoppingCartPlus } from "@vicons/tabler";
import { NIcon, NButton, NCard, NTable } from 'naive-ui'
import { Product } from "@/types/Product";
import { useRoute, useRouter } from 'vue-router'
import { ref, onBeforeMount } from 'vue'
import { useProductStore } from '@/stores/ProductStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const product = ref<Product | null>()
const store = useProductStore()

onBeforeMount(() => {
    product.value = store.products[parseInt(route.params.id as string)];

})

const goBack = function () {
    if (window.history.length > 1) {
        router.go(-1)
    }
    else {
        router.push('/')
    }
}

return (_ctx: any,_cache: any) => {
  return (product.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(product.value.name + ((product.value.details === '') ? '' : ' - ' + product.value.details)), 1),
        _createVNode(_unref(NCard), null, {
          cover: _withCtx(() => [
            _createElementVNode("img", {
              style: {"box-sizing":"border-box","height":"300px","object-fit":"cover"},
              src: require(`@/assets/img/products/${product.value.image}`)
            }, null, 8, _hoisted_2)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(NTable), {
              style: {"margin-top":"20px"},
              bordered: false,
              "single-line": true,
              size: "small"
            }, {
              default: _withCtx(() => [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, "#" + _toDisplayString(product.value.catelogId), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_5,
                    _createElementVNode("td", null, _toDisplayString((typeof (product.value.price) === 'number') ?
                                    '$ ' + (product.value.price / 100 * 75).toFixed(2).toString() + ',-' :
                                    product.value.price), 1)
                  ]),
                  (product.value.details !== '')
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("td", null, _toDisplayString(product.value.details), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (product.value.specs !== '')
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("td", null, _toDisplayString(product.value.specs), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (product.value.description !== '')
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("td", {
                          innerHTML: product.value.description
                        }, null, 8, _hoisted_12)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(NButton), {
              strong: "",
              secondary: "",
              circle: "",
              size: "large",
              class: "back",
              "on-click": goBack
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(NIcon), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowLeft))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})